import { PaletteOptions, ThemeOptions } from '@mui/material';
import { defaultThemeOptions } from './';

// Raw F5 design-system tokens mapped into the palette slots this app uses.
const F5DesignTokens = {
  dodgerBlue: { base: '#4F73FF', hover: '#4164ED', light: '#DBE2FF' },
  blueZodiac: '#0F1E57',
  midnight: '#0B1640',
  // Neutral (n100 → n500)
  athens: '#F7F8FA',
  catskill: '#E6E9F3',
  haze: '#CFD4E2',
  gull: '#9EA7B8',
  raven: '#6C778C',
  emerald: { base: '#35D068', light: '#D0F5DC' },
  pomegranate: { base: '#F94627', light: '#FFDAD4' },
  amber: { base: '#FFC400', light: '#FFF3CC' },
  java: { base: '#1ACB9A', light: '#CBF5E9' },
} as const;

const palette: PaletteOptions = {
  common: {
    black: F5DesignTokens.midnight,
    white: '#ffffff',
  },
  subtleGray: F5DesignTokens.athens,
  lightGray: F5DesignTokens.catskill,
  gray: F5DesignTokens.gull,
  darkGray: F5DesignTokens.raven,
  divider: F5DesignTokens.catskill,
  background: {
    paper: '#ffffff',
    default: '#ffffff',
  },
  surface: {
    primary: {
      main: F5DesignTokens.midnight,
    },
    secondary: {
      main: F5DesignTokens.blueZodiac,
    },
    info: {
      main: F5DesignTokens.java.light,
    },
    error: {
      main: F5DesignTokens.pomegranate.light,
    },
    warning: {
      main: F5DesignTokens.amber.light,
    },
    success: {
      main: F5DesignTokens.emerald.light,
    },
    disabled: {
      main: F5DesignTokens.athens,
    },
  },
  primary: {
    main: F5DesignTokens.dodgerBlue.base,
    light: F5DesignTokens.dodgerBlue.light,
  },
  secondary: {
    main: F5DesignTokens.blueZodiac,
  },
  link: {
    main: F5DesignTokens.blueZodiac,
    hover: F5DesignTokens.dodgerBlue.base,
  },
  tooltip: {
    background: F5DesignTokens.blueZodiac,
  },
  success: {
    main: F5DesignTokens.emerald.base,
  },
  error: {
    main: F5DesignTokens.pomegranate.base,
  },
  warning: {
    main: F5DesignTokens.amber.base,
  },
  info: {
    main: F5DesignTokens.blueZodiac,
  },
};

export const F5Theme: ThemeOptions = {
  ...defaultThemeOptions,
  palette,
};
